<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    :stroke-width="stroke"
    stroke-linecap="round"
    stroke-linejoin="round"
    class="guild-icon"
    aria-hidden="true"
  >
    <!-- Taverne / Hub -->
    <g v-if="name === 'taverne'">
      <path d="M4 21h16" />
      <path d="M6 21v-8a2 2 0 012-2h8a2 2 0 012 2v8" />
      <path d="M3 13l9-8 9 8" />
      <circle cx="12" cy="11" r="2" />
      <path d="M12 13v4" />
    </g>

    <!-- Quêtes / Épée -->
    <g v-else-if="name === 'quests'">
      <path d="M8 16l8-8" />
      <path d="M7 7h4v4" />
      <path d="M13 13h4v4" />
      <path d="M3 21l6-6" />
      <path d="M15 3l6 6-3 3-6-6 3-3z" />
    </g>

    <!-- Carte -->
    <g v-else-if="name === 'map'">
      <path d="M9 5l6 3 5-3v13l-5 3-6-3-5 3V8l5-3z" />
      <circle cx="12" cy="11" r="3" />
    </g>

    <!-- Boutique / Sac -->
    <g v-else-if="name === 'shop'">
      <path d="M6 7h12l1 10a2 2 0 01-2 2H7a2 2 0 01-2-2L6 7z" />
      <path d="M9 7V5a3 3 0 016 0v2" />
      <path d="M10 11h4" />
    </g>

    <!-- Coffre / Wallet -->
    <g v-else-if="name === 'wallet'">
      <path d="M3 7h18a2 2 0 012 2v10a2 2 0 01-2 2H3" />
      <path d="M3 7V6a2 2 0 012-2h14" />
      <circle cx="15" cy="14" r="2" />
      <path d="M15 14h4" />
    </g>

    <!-- Familier / Pattes -->
    <g v-else-if="name === 'pet'">
      <ellipse cx="8" cy="13" rx="3" ry="4" />
      <ellipse cx="16" cy="13" rx="3" ry="4" />
      <ellipse cx="12" cy="16" rx="3" ry="3.5" />
      <path d="M10 13l1-3 1 3" />
    </g>

    <!-- Profil -->
    <g v-else-if="name === 'profile'">
      <circle cx="12" cy="8" r="4" />
      <path d="M5 20a7 7 0 0114 0" />
    </g>

    <!-- Codex / Livre -->
    <g v-else-if="name === 'book'">
      <path d="M4 19.5A2.5 2.5 0 016.5 17H20" />
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 014 19.5v-15A2.5 2.5 0 016.5 2z" />
    </g>

    <!-- Escouade / Bouclier + plus -->
    <g v-else-if="name === 'party'">
      <path d="M12 3l8 4v6c0 5-4 8-8 10-4-2-8-5-8-10V7l8-4z" />
      <path d="M12 8v8" />
      <path d="M8 12h8" />
    </g>

    <!-- SOS / Alerte -->
    <g v-else-if="name === 'sos'">
      <path d="M12 4a8 8 0 100 16 8 8 0 000-16z" />
      <path d="M12 8v5" />
      <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" />
    </g>

    <!-- Chat -->
    <g v-else-if="name === 'chat'">
      <path d="M21 11a8 8 0 01-16 0 8 8 0 0116 0z" />
      <path d="M8 14l-3 5 5-2" />
    </g>

    <!-- Pièces / Cuivres -->
    <g v-else-if="name === 'coins'">
      <ellipse cx="9" cy="12" rx="5" ry="6" />
      <ellipse cx="15" cy="12" rx="5" ry="6" />
      <path d="M9 12c0-2.5 2.5-4 6-4" />
    </g>

    <!-- Close -->
    <g v-else-if="name === 'close'">
      <path d="M18 6L6 18" />
      <path d="M6 6l12 12" />
    </g>

    <!-- Check -->
    <g v-else-if="name === 'check'">
      <path d="M4 12l5 5 11-11" />
    </g>

    <!-- Arrow -->
    <g v-else-if="name === 'arrow'">
      <path d="M5 12h14" />
      <path d="M12 5l7 7-7 7" />
    </g>

    <!-- Settings -->
    <g v-else-if="name === 'settings'">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a2 2 0 00.4 1.6l.1.1a2 2 0 11-2.8 2.8l-.1-.1a2 2 0 00-1.6-.4h-.3a2 2 0 00-1.6.4l-.1.1a2 2 0 11-2.8-2.8l.1-.1a2 2 0 00.4-1.6V15a2 2 0 00-.4-1.6l-.1-.1a2 2 0 112.8-2.8l.1.1a2 2 0 001.6.4h.3a2 2 0 001.6-.4l.1-.1a2 2 0 112.8 2.8l-.1.1a2 2 0 00-.4 1.6z" />
    </g>

    <!-- Test 2D / Puppet -->
    <g v-else-if="name === 'test-2d'">
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <circle cx="12" cy="9" r="3" />
      <path d="M7 18c0-2.8 2.2-5 5-5s5 2.2 5 5" />
    </g>

    <!-- Test GLB / 3D Cube -->
    <g v-else-if="name === 'test-glb'">
      <path d="M12 2l8 4.5v11L12 22 4 17.5v-11L12 2z" />
      <path d="M12 12l8-4.5M12 12v10M12 12L4 7.5" />
    </g>

    <!-- Test Low Poly / Mesh triangle -->
    <g v-else-if="name === 'test-low-poly'">
      <polygon points="12 2 22 20 2 20" />
      <path d="M12 2v18M2 20h20" />
      <circle cx="12" cy="14" r="1.5" fill="currentColor" stroke="none" />
    </g>

    <!-- Donjon / Tour -->
    <g v-else-if="name === 'dungeon'">
      <path d="M6 21h12" />
      <path d="M8 21V8l4-4 4 4v13" />
      <path d="M10 11h4M10 15h4" />
      <path d="M7 8h2M15 8h2" />
    </g>

    <!-- QR / Scan -->
    <g v-else-if="name === 'qr'">
      <rect x="3" y="3" width="6" height="6" rx="1" />
      <rect x="15" y="3" width="6" height="6" rx="1" />
      <rect x="3" y="15" width="6" height="6" rx="1" />
      <path d="M15 15h6v2h-4v4h-2V15z" />
    </g>

    <!-- Potion -->
    <g v-else-if="name === 'potion'">
      <path d="M10 2h4v5l4 4v9a2 2 0 01-2 2H8a2 2 0 01-2-2v-9l4-4V2z" />
      <path d="M12 10v7" />
      <circle cx="12" cy="15" r="1.5" fill="currentColor" stroke="none" />
    </g>

    <!-- Parchemin -->
    <g v-else-if="name === 'scroll'">
      <path d="M6 3h12a2 2 0 012 2v14a2 2 0 01-2 2H6" />
      <path d="M6 3v15" />
      <path d="M6 18H5a2 2 0 010-4h1" />
      <path d="M9 7h6M9 11h6M9 15h4" />
    </g>

    <!-- Arme / Rifle -->
    <g v-else-if="name === 'weapon'">
      <path d="M3 16l5-5 1 1-5 5-1-1z" />
      <path d="M8 12l8-8 2 2-8 8-2-2z" />
      <path d="M16 4l4 4" />
      <path d="M4 20l3-3" />
    </g>

    <!-- Bouclier -->
    <g v-else-if="name === 'shield'">
      <path d="M12 3l8 4v6c0 5-4 8-8 10-4-2-8-5-8-10V7l8-4z" />
      <path d="M9 12l2 2 4-4" />
    </g>

    <!-- Cœur -->
    <g v-else-if="name === 'heart'">
      <path d="M20.4 4.6a5.5 5.5 0 00-7.8 0L12 5.3l-.6-.7a5.5 5.5 0 00-7.8 7.8l.7.7L12 21l7.7-7.7.7-.7a5.5 5.5 0 000-7.8z" />
    </g>

    <!-- Énergie / Photon -->
    <g v-else-if="name === 'energy'">
      <path d="M13 2L4 14h7l-2 8 9-12h-7l2-8z" />
      <circle cx="12" cy="12" r="10" opacity="0.15" />
    </g>

    <!-- Étoile -->
    <g v-else-if="name === 'star'">
      <polygon points="12 2 15 9 22 9 16 14 18 21 12 17 6 21 8 14 2 9 9 9" />
    </g>

    <!-- Soleil -->
    <g v-else-if="name === 'sun'">
      <circle cx="12" cy="12" r="5" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
    </g>

    <!-- Lune -->
    <g v-else-if="name === 'moon'">
      <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
    </g>

    <!-- Palette / Thème -->
    <g v-else-if="name === 'palette'">
      <circle cx="12" cy="12" r="9" />
      <circle cx="8" cy="10" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15" cy="8" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="16" cy="14" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="10" cy="16" r="1.5" fill="currentColor" stroke="none" />
    </g>

    <!-- Location / me localiser -->
    <g v-else-if="name === 'location'">
      <path d="M12 2a7 7 0 00-7 7c0 4.5 7 13 7 13s7-8.5 7-13a7 7 0 00-7-7z" />
      <circle cx="12" cy="9" r="2.5" fill="currentColor" stroke="none" />
    </g>

    <!-- Refresh / recherche en cours -->
    <g v-else-if="name === 'refresh'">
      <path d="M21 12a9 9 0 11-3-6.7" />
      <path d="M21 5v5h-5" />
    </g>

    <!-- Fallback -->
    <g v-else>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v8M8 12h8" />
    </g>
  </svg>
</template>

<script setup lang="ts">
defineProps({
  name: { type: String, required: true },
  size: { type: [Number, String], default: 24 },
  stroke: { type: [Number, String], default: 2 }
});
</script>

<style scoped>
.guild-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
